const HomeFeatures = () => {
  return (
    <section className="py-24 px-6 relative">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-4 gap-12">
          <div className="group text-center">
            <div className="w-16 h-16 mx-auto mb-6 bg-gradient-to-br from-gray-100 to-gray-200 dark:from-gray-800 dark:to-gray-700 flex items-center justify-center transition-all duration-500 group-hover:shadow-lg">
              <svg className="w-8 h-8 text-gray-600 dark:text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
              </svg>
            </div>
            <h3 className="text-lg font-light mb-4 text-gray-900 dark:text-white tracking-wide">Adaptive Intelligence</h3>
            <p className="text-sm font-light text-gray-600 dark:text-gray-300 leading-relaxed tracking-wide">
              Learns your style DNA and your closet's realities to refine outfit generation with every wear and save.
            </p>
          </div>

          <div className="group text-center">
            <div className="w-16 h-16 mx-auto mb-6 bg-gradient-to-br from-gray-100 to-gray-200 dark:from-gray-800 dark:to-gray-700 flex items-center justify-center transition-all duration-500 group-hover:shadow-lg">
              <svg className="w-8 h-8 text-gray-600 dark:text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
              </svg>
            </div>
            <h3 className="text-lg font-light mb-4 text-gray-900 dark:text-white tracking-wide">Intuitive Expression</h3>
            <p className="text-sm font-light text-gray-600 dark:text-gray-300 leading-relaxed tracking-wide">
              Translate intent into outfits—'effortlessly chic' to 'editorial bold'—grounded in the garments you actually own.
            </p>
          </div>

          <div className="group text-center">
            <div className="w-16 h-16 mx-auto mb-6 bg-gradient-to-br from-gray-100 to-gray-200 dark:from-gray-800 dark:to-gray-700 flex items-center justify-center transition-all duration-500 group-hover:shadow-lg">
              <svg className="w-8 h-8 text-gray-600 dark:text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
              </svg>
            </div>
            <h3 className="text-lg font-light mb-4 text-gray-900 dark:text-white tracking-wide">Capsule Curation</h3>
            <p className="text-sm font-light text-gray-600 dark:text-gray-300 leading-relaxed tracking-wide">
              Design capsules from your current wardrobe, then auto-generate interchangeable looks for trips, weeks, or seasons.
            </p>
          </div>

          <div className="group text-center">
            <div className="w-16 h-16 mx-auto mb-6 bg-gradient-to-br from-gray-100 to-gray-200 dark:from-gray-800 dark:to-gray-700 flex items-center justify-center transition-all duration-500 group-hover:shadow-lg">
              <svg className="w-8 h-8 text-gray-600 dark:text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
              </svg>
            </div>
            <h3 className="text-lg font-light mb-4 text-gray-900 dark:text-white tracking-wide">Conscious Luxury</h3>
            <p className="text-sm font-light text-gray-600 dark:text-gray-300 leading-relaxed tracking-wide">
              Wardrobe management that honors personal expression and environmental stewardship through elegant reuse—not excess.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeFeatures;
